import { createIdentifier } from '@blocksuite/global/di';
import type * as Y from 'yjs';

import type { Store, StoreOptions, YBlock } from '../../model';
import type { AwarenessStore } from '../../yjs';
import type { Workspace } from './workspace.js';
import type { DocMeta } from './workspace-meta.js';

export type YSuggestionInfo = {
  list: any[];
};

export type GetStoreOptions = Omit<StoreOptions, 'schema' | 'doc'>;
export type RemoveStoreOptions = Pick<
  StoreOptions,
  'query' | 'id' | 'readonly'
>;

export interface Doc {
  readonly id: string;
  get meta(): DocMeta | undefined;

  remove(): void;
  load(initFn?: () => void): void;
  /**
   * ✅ 卸载 doc，释放 Awareness（但不销毁整个 Doc）
   * 当用户切换到其他 doc 时调用，避免 Awareness 的 setInterval 定时器导致内存泄漏
   */
  unload(): void;
  get ready(): boolean;
  dispose(): void;

  clear(): void;
  getStore(options?: GetStoreOptions): Store;
  removeStore(options: RemoveStoreOptions): void;

  get loaded(): boolean;
  get awarenessStore(): AwarenessStore;

  get workspace(): Workspace;

  get rootDoc(): Y.Doc;
  get spaceDoc(): Y.Doc;
  get yBlocks(): Y.Map<YBlock>;
  get ySuggestionInfo(): Y.Map<YSuggestionInfo>;
}

export const DocIdentifier = createIdentifier<Doc>('store-doc');
